import { render, staticRenderFns } from "./InstructionsDetailedStep2.vue?vue&type=template&id=619b2698&"
import script from "./InstructionsDetailedStep2.vue?vue&type=script&lang=js&"
export * from "./InstructionsDetailedStep2.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsDetailedStep2.vue?vue&type=style&index=0&id=619b2698&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports